var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.token && _vm.token !== null)?_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"modal"},[_vm._m(0),_c('div',{staticClass:"p-3"},[_c('p',[_vm._v("You have left this browser idle for 30 minutes.")]),_c('p',[_vm._v(_vm._s(_vm.time)+" second left")])])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal__title"},[_c('span',[_vm._v("Session Expired")])])
}]

export { render, staticRenderFns }